import React from "react"

import { useKeyboardFocus, useViewportHeight, useZoomAdjustment } from "@/shared/hooks"

import { Global } from "@/shared/components"

export const CommonLayout: React.FC<React.PropsWithChildren> = ({ children }) => {
  useKeyboardFocus()
  useViewportHeight({ updateOnResize: true })
  useZoomAdjustment()

  return <Global>{children}</Global>
}
